import React from "react";
import { motion } from "framer-motion";
import { cellKey } from "@/lib/game/numberPlacement";

const stateClass = {
  empty: "bg-white text-ink",
  given: "bg-white text-ink",
  hint: "bg-[#FFC043]/30 text-[#7c5300]",
  correct: "bg-[#4CAF50]/20 text-[#166534]",
  error: "bg-[#F44336]/20 text-[#b91c1c]",
};

export const Board = ({ puzzle, cellData, onCellClick, onDropCell, dragging, anim }) => {
  const { rows, cols, grid } = puzzle;

  return (
    <div className="w-full max-w-[540px] mx-auto select-none">
      <div
        className="bg-ink p-1.5 rounded-xl border-4 border-ink shadow-brutal-lg"
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
          gap: "4px",
        }}
      >
        {grid.map((row, r) =>
          row.map((_, c) => {
            const k = cellKey(r, c);
            const d = cellData(r, c);
            if (d.blocked) {
              return <div key={k} className="aspect-square bg-ink rounded-[3px]" aria-hidden />;
            }
            const shake = anim.shake.has(k);
            const pulse = anim.pulse.has(k);
            const cls = d.highlight
              ? "bg-[#FFC043]/45 ring-2 ring-inset ring-[#FFC043] text-ink"
              : stateClass[d.state] || stateClass.empty;
            const bold = d.state === "given" ? "font-bold" : "font-extrabold";
            return (
              <motion.button
                key={k}
                type="button"
                data-testid={`grid-cell-${r}-${c}`}
                onClick={() => onCellClick(r, c)}
                onDragOver={(e) => {
                  if (dragging) e.preventDefault();
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  onDropCell(r, c);
                }}
                animate={{
                  x: shake ? [-4, 4, -4, 4, 0] : 0,
                  scale: pulse ? [1, 1.18, 1] : 1,
                }}
                transition={{ duration: 0.42 }}
                className={`aspect-square rounded-[4px] flex items-center justify-center font-mono ${bold} text-[clamp(0.7rem,3.6vw,1.5rem)] leading-none transition-colors ${cls}`}
              >
                {d.digit}
              </motion.button>
            );
          })
        )}
      </div>
    </div>
  );
};
